import React from 'react';
import AmountInput from './AmountInput';
import { lineTotal } from './computeBillingKpis';
import { scaleToTotal } from './stats';
import { rotateValuesForDisplay } from './monthRotation';
// no month labels needed in list item (mini sparkline has no x labels)
import { rowColor } from './colors';
import MiniSparkline from './MiniSparkline';
import { useP } from '../../../i18n/useP';

// One revenue line in the left rail.
// Layout : accent border-left + label/subtitle (top), editable annual total
// + coefficient-of-variation % (bottom), and a mini sparkline on the right.
// Clicking anywhere outside the inputs focuses the line in the detail panel.
export default function RevenueListItem({
  revenue,
  colorIndex = 0,
  startMonth = 0,
  selected = false,
  locked = false,
  canMoveUp = false,
  canMoveDown = false,
  onMoveUp,
  onMoveDown,
  onSelect,
  onPatch,
}) {
  const p = useP();
  const total = lineTotal(revenue);
  const accent = rowColor(colorIndex);
  const displayValues = rotateValuesForDisplay(revenue.monthly_values, startMonth);
  const untitled = p('Sans titre');
  const lineWord = p('ligne');

  function commitTotal(newTotal) {
    if (newTotal === total) return;
    const next = scaleToTotal(revenue.monthly_values || [], newTotal);
    onPatch({ monthly_values: next });
  }

  return (
    <div
      className={`billing-list__item ${selected ? 'billing-list__item--selected' : ''}`}
      style={{ borderLeftColor: accent }}
      role="button"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={(e) => {
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'BUTTON') return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect(); }
      }}
    >
      <div className="billing-list__item-text">
        <span className="billing-list__item-label">
          {revenue.label || untitled}
        </span>
        <div className="billing-list__item-meta">
          <AmountInput
            value={total}
            onCommit={commitTotal}
            disabled={locked}
            ariaLabel={p('Total annuel — {{label}}').replace('{{label}}', revenue.label || lineWord)}
            className="billing-list__item-total-input"
          />
        </div>
      </div>
      <MiniSparkline
        values={displayValues}
        color={accent}
        width={120}
        height={36}
      />
      {!locked && (
        <div
          className="billing-list__item-reorder"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            className="billing-list__reorder-btn"
            disabled={!canMoveUp}
            onClick={(e) => { e.stopPropagation(); if (canMoveUp) onMoveUp(); }}
            title={p('Monter la ligne')}
            aria-label={p('Monter la ligne')}
          >
            <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
              <path d="M5 2 L9 7 L1 7 Z" fill="currentColor" />
            </svg>
          </button>
          <button
            type="button"
            className="billing-list__reorder-btn"
            disabled={!canMoveDown}
            onClick={(e) => { e.stopPropagation(); if (canMoveDown) onMoveDown(); }}
            title={p('Descendre la ligne')}
            aria-label={p('Descendre la ligne')}
          >
            <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
              <path d="M5 8 L1 3 L9 3 Z" fill="currentColor" />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
}
